import React from 'react';
import numeral from 'numeral';

function NumeralMetric (props) {
	const number = props.children;

	let formatedNumber;
	if (number >= 1000000) {
		formatedNumber = numeral(number).format('0.0a').toUpperCase();
	} else if (number >= 1000) {
		formatedNumber = numeral(number).format('0a').toUpperCase();
	} else {
		formatedNumber = number;
	}

	return (<span alt={number} {...props}>{formatedNumber}</span>);
}

export default NumeralMetric;
